<template>
  <div class="md-layout new-feed" style="padding: 15px;" id="new-feed-content">
    <div class="md-layout-item new-feed__posts" style="padding: 0; z-index: 0;">
      <create-post></create-post>
      <div class="loading-holder-post post-layout" v-if="loadPageHolder && postId == undefined">
        <div class="container-metadata">
          <div class="loader-shimmer loading-image-holder">
          </div>
          <div class="metadata-content">
              <p class="loading-holder text-1-line loader-shimmer"></p>
              <p class="loading-holder text-2-line loader-shimmer"></p>
              <p class="loading-holder text-1-line loader-shimmer"></p>
          </div>
        </div>
      </div>
      <template v-if="postId != undefined">
        <post-layout v-if="postDetail && postDetail.post" :post="postDetail" :isPost="true"></post-layout>
        <div v-else-if="loadPageHolder" class="loading-holder-post post-layout">
          <div class="container-metadata">
            <div class="loader-shimmer loading-image-holder"></div>
            <div class="metadata-content">
              <p class="loading-holder text-1-line loader-shimmer"></p>
              <p class="loading-holder text-2-line loader-shimmer"></p>
              <p class="loading-holder text-1-line loader-shimmer"></p>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <vue-loadmore
            v-if="loadPageHolder || posts.length > 0"
            :on-loadmore="onLoad"
            :finished="finished"
            :loading-text="loadingText"
            :load-offset="400"
            :finished-text="finishedText">
          <div v-for="post of posts" :key="post.id" class="new-feed-item" :data-id="post.post.id"
               :data-read="post.post.is_read">
            <post-layout :post=post></post-layout>
          </div>
        </vue-loadmore>

        <section v-else class="agency-welcome">
          <div class="agency-welcome__decor agency-welcome__decor--1" aria-hidden="true"></div>
          <div class="agency-welcome__decor agency-welcome__decor--2" aria-hidden="true"></div>
          <div class="agency-welcome__decor agency-welcome__decor--3" aria-hidden="true"></div>

          <div class="agency-welcome__inner">
            <div class="agency-welcome__badge">
              <span class="material-symbols-outlined">verified</span>
              <span>{{ welcomeBrand.bold }} {{ welcomeBrand.normal }}</span>
            </div>

            <h2 class="agency-welcome__title">
              Chào mừng <span class="agency-welcome__title-accent">{{ welcomeUserName }}</span>
            </h2>
            <p class="agency-welcome__subtitle">
              Đây là Bảng tin của bạn — nơi đồng nghiệp chia sẻ thông báo, cập nhật và những cột mốc quan trọng.
              Hiện tại chưa có bài viết nào — hãy bắt đầu kết nối ngay hôm nay.
            </p>

            <div class="agency-welcome__actions">
              <button type="button" class="agency-welcome__btn agency-welcome__btn--primary" @click="openChatMenu">
                <span class="material-symbols-outlined">forum</span>
                Trao đổi công việc
              </button>
            </div>

            <ul class="agency-welcome__highlights">
              <li>
                <span class="material-symbols-outlined">campaign</span>
                <div>
                  <strong>Thông báo nội bộ</strong>
                  <p>Cập nhật chính sách, sự kiện và tin tức được hệ thống tổng hợp ở cột bên phải.</p>
                </div>
              </li>
              <li>
                <span class="material-symbols-outlined">forum</span>
                <div>
                  <strong>Trao đổi nhanh</strong>
                  <p>Nhắn tin, gắn thẻ và bình luận trực tiếp trên bài viết để cộng tác hiệu quả.</p>
                </div>
              </li>
              <li>
                <span class="material-symbols-outlined">insights</span>
                <div>
                  <strong>Theo dõi nhóm</strong>
                  <p>Ghim nhóm yêu thích để không bỏ lỡ bài đăng quan trọng từ phòng ban.</p>
                </div>
              </li>
            </ul>
          </div>
        </section>
      </template>
    </div>
    <div class="company-info-section">
      <md-card class="group-chat-announcements-block background_neutral_white mb-20px">
        <div class="group-chat-announcements-block__header text-500-medium">Thông báo từ hệ thống</div>
        <ChatSystemAnnouncementsFeed :limit="10" :show-group-name="true" />
      </md-card>
      <md-card class="group-chat-announcements-block background_neutral_white mb-20px">
        <div class="group-chat-announcements-block__header text-500-medium">Thông báo từ tin nhắn</div>
        <ChatAnnouncementsFeed
          mode="cross_group"
          :limit="5"
          :show-group-name="true"
        />
      </md-card>
    </div>
    <update-post-modal @update-post="updatePostData"></update-post-modal>
    <update-comment-modal @update-comment="updateCommentData"></update-comment-modal>
  </div>
</template>
<script>

import PostLayout from "../../Layout/Newfeed/PostLayout";
import PostService from "../../../store/services/PostService";
import CreatePost from "../../Components/Post/UserCreatePost/createPost";
import ChatAnnouncementsFeed from "./Messager/Infomation/ChatAnnouncementsFeed.vue";
import ChatSystemAnnouncementsFeed from "./Messager/Infomation/ChatSystemAnnouncementsFeed.vue";
import UpdatePostModal from "../../Components/Modal/UpdatePostModal";
import UpdateCommentModal from "../../Components/Modal/UpdateCommentModal";
import $ from "jquery";
import NotificationService from "../../../store/services/NotificationService";
import { parseLoginBrand, parseAgencyBranchBrand } from "../../../helper/loginBrand";
import {
  agencyBranchConfigUrl,
  isAgencySocialSite,
} from "@/config/agencyRuntime";
import axios from "axios";

export default {
  components: {
    UpdateCommentModal,
    CreatePost,
    PostLayout,
    ChatAnnouncementsFeed,
    ChatSystemAnnouncementsFeed,
    UpdatePostModal,
  },
  created() {
    if (this.postId !== undefined) {
      this.getPost();
    } else {
      const cachedPosts = this.$store.state.post.posts || [];
      if (cachedPosts.length > 0) {
        this.posts = cachedPosts;
        this.loadPageHolder = false;
        this.getPosts(false, { silent: true });
      } else {
        this.getPosts();
      }
    }
    this.loadAgencyBranchBrand();
    localStorage.setItem('link', this.$route.fullPath)
  },
  data() {
    return {
      feedScrollHandler: null,
      posts: [],
      isFetchingPosts: false,
      params: {
        page: 1,
        per_page: 10,
      },
      finished: false,
      last_page: 1,
      loadingText: 'Đang tải',
      finishedText: 'Không còn bài viết mới nào.',
      postDetail: {},
      postId: this.$route.params.post_id,
      postIdsIsRead: [],
      loadPageHolder: true,
      agencyBrand: null,
    };
  },
  computed: {
    welcomeBrand() {
      if (this.agencyBrand) {
        return this.agencyBrand;
      }
      if (isAgencySocialSite()) {
        return { bold: "AGENCY", normal: "PORTAL" };
      }
      const host = typeof window !== "undefined" ? window.location.hostname : "";
      return parseLoginBrand(host);
    },
    welcomeUserName() {
      const user = this.$store?.state?.auth?.user || {};
      return user.fullname || user.username || "bạn";
    },
  },
  mounted() {
    const scrollEl = this.getFeedScrollContainer();
    if (scrollEl) {
      this.feedScrollHandler = () => {
        const pageYOffset = scrollEl.scrollTop;
        let totalItemHeight = 300;
        for (const item of $(".new-feed-item")) {
          totalItemHeight += item.offsetHeight;
          const id = item.dataset.id;
          const isRead = item.dataset.read;
          if (totalItemHeight <= pageYOffset && (isRead == "false" || !isRead) && this.postIdsIsRead.indexOf(id) === -1) {
            this.userReadPost(id);
            this.postIdsIsRead.push(id);
          }
        }
      };
      scrollEl.addEventListener("scroll", this.feedScrollHandler, { passive: true });
    }

    if (this.$store.state.post.contentScrollTop !== 0 && scrollEl) {
      scrollEl.scrollTop = this.$store.state.post.contentScrollTop;
    }

    setTimeout(() => {
      const fcmToken = localStorage.getItem("cmf_token");
      const sendCmfToken = localStorage.getItem("send_cmf_token");
      if (fcmToken != null && sendCmfToken != 'true') {
        NotificationService.postFcmToken({token: fcmToken}).then(res => {
          localStorage.setItem("send_cmf_token", true);
        });
      }
    }, 1000);
  },
  beforeDestroy() {
    const scrollEl = this.getFeedScrollContainer();
    if (scrollEl && this.feedScrollHandler) {
      scrollEl.removeEventListener("scroll", this.feedScrollHandler);
      this.feedScrollHandler = null;
    }
  },
  watch: {
    '$store.state.post.posts': function (newVal, oldVal) {
      this.posts = newVal
    },
    '$route.params.post_id'(to, from) {
      this.postId = this.$route.params.post_id;
      this.getPost();
    },
  },
  methods: {
    /** Khối nội dung chính (.content) là scroll container — không scroll chung với cột company-info. */
    getFeedScrollContainer() {
      return this.$el && typeof this.$el.closest === "function" ? this.$el.closest(".content") : null;
    },
    async getPosts(loadMore = false, options = {}) {
      const silent = options.silent === true;
      if (this.isFetchingPosts) {
        return;
      }

      if (!loadMore && !silent && this.posts.length === 0) {
        this.loadPageHolder = true;
      }

      this.isFetchingPosts = true;
      try {
        const routerName = localStorage.getItem('router_name');
        if (routerName !== 'PostDetail') {
          const requestParams = loadMore
            ? this.params
            : { ...this.params, page: 1 };
          const res = await PostService.getPosts(requestParams);
          if (res) {
            this.last_page = res.meta.last_page;
            if (loadMore) {
              this.posts = this.posts.concat(res.data);
            } else {
              this.posts = res.data;
              if (!loadMore) {
                this.params.page = 1;
              }
            }
            this.$store.commit("updatePost", this.posts);
          }
        } else {
          this.posts = this.$store.state.post.posts;
        }
      } catch (e) {
        void e;
      } finally {
        this.isFetchingPosts = false;
        this.loadPageHolder = false;
        localStorage.removeItem('router_name');
      }
    },
    onRefresh(done) {
      this.posts = [];
      this.params.page = 1;
      this.finished = false;
      this.getPosts();
      done();
    },
    onLoad(done) {
      if (this.params.page < this.last_page && !this.isFetchingPosts) {
        this.params.page++
        this.getPosts(true);
      } else {
        this.finished = true;
      }
      done();
    },
    updatePostData(e) {
      for (let i = 0; i < this.posts.length; i++) {
        if (this.posts[i].post.id === e.id) {
          this.posts[i].post = e;
        }
      }
    },
    updateCommentData(e) {
      let postParentId = e.postParentId;
      let commentData = e.commentData;
      for (let i = 0; i < this.posts.length; i++) {
        if (this.posts[i].post.id === postParentId) {
          for (let j = 0; j < this.posts[i].comments.length; j++) {
            if (this.posts[i].comments[j].id === commentData.id) {
              this.posts[i].comments[j] = commentData;
            }
          }
        }
      }
    },
    async getPost() {
      if (!this.postDetail || !this.postDetail.post) {
        this.loadPageHolder = true;
      }
      try {
        const res = await PostService.getPost({ post_id: this.postId });
        if (res) {
          this.postDetail = res.data;
        }
      } finally {
        this.loadPageHolder = false;
      }
    },
    userReadPost(postId) {
      PostService.userReadPost(postId).then(res => {
      });
    },
    async loadAgencyBranchBrand() {
      const url = agencyBranchConfigUrl();
      if (!url) {
        return;
      }
      try {
        const { data } = await axios.get(url);
        if (data && data.status && data.data) {
          this.agencyBrand = parseAgencyBranchBrand(data.data);
        }
      } catch {
        /* fallback parseLoginBrand từ hostname */
      }
    },
    openChatMenu() {
      const selected = this.$store?.state?.chat?.chatGroupSelected;
      if (selected && selected.id) {
        this.$router.push("/messenger/" + selected.id).catch((err) => {
          if (!err || err.name !== "NavigationDuplicated") throw err;
        });
        return;
      }
      this.$router.push("/messenger/0").catch((err) => {
        if (!err || err.name !== "NavigationDuplicated") throw err;
      });
    },
  }
};
</script>
<style lang="css">
.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #232d34; /* Blue */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 2s linear infinite;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/* Hai cột: bài viết theo scroll của .content; cột phải dính viewport và chỉ cuộn nội bộ khi dài */
.new-feed {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
}

.new-feed__posts {
  flex: 1 1 auto;
  min-width: 0;
  width: auto !important;
}

.company-info-section {
  flex: 0 0 300px;
  width: 300px;
  margin: 0 0 0 15px;
  position: sticky;
  top: 0px;
  align-self: flex-start;
  max-height: calc(100vh - 96px);
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.group-chat-announcements-block {
  padding: 12px 15px 10px;
  border-radius: 10px;
  overflow: hidden;

  &.md-card {
    box-shadow: none !important;
    border: 1px solid rgba(0, 0, 0, 0.08);
  }

  &__header {
    padding-bottom: 10px;
    margin-bottom: 8px;
    border-bottom: 1px solid #eee;
  }
}

/*.vuejs-loadmore-finished-text:before {*/
/*  content: 'Đã hết bài post' !important;*/
/*}*/

/*.vuejs-loadmore-loading:before {*/
/*  content: 'Đang Tải' !important;*/
/*}*/

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loading-holder-post{
    .container-metadata{
      text-decoration: none;
      font-weight: normal;
      font-size: 15px;
      border: 1px solid rgba(0, 0, 0, 0.1803921569);
      position: relative;
      overflow: hidden;
      background-color: #fff;
      border-radius: 12px;
      margin-top: 2px;
      padding: 5px;
      .loading-image-holder{
        min-height: 100px;
        margin: 5px;
      }
    }
    .loader-shimmer{
      animation-duration: 2.2s;
      animation-fill-mode: forwards;
      animation-iteration-count: infinite;
      animation-name: shimmer-holder;
      animation-timing-function: linear;
      background: #ddd;
      background: linear-gradient(to right, #f7f6f6 8%, #efefef 18%, #F6F6F6 33%);
      background-size: 1200px 100%;
      color: transparent;
      height: 20px;
      margin: 5px;
      img{
        display: none;
      }
    }
}

@-webkit-keyframes shimmer-holder {
    0% {
        background-position: -100% 0;
    }
    100% {
        background-position: 100% 0;
    }
}

@keyframes shimmer-holder {
    0% {
        background-position: -1200px 0;
    }
    100% {
        background-position: 1200px 0;
    }
}

/* === Agency Welcome (empty feed) — Light theme ============================== */
.agency-welcome {
  position: relative;
  max-width: 750px;
  margin: 16px auto 0;
  padding: 40px 36px 36px;
  border-radius: 20px;
  overflow: hidden;
  isolation: isolate;
  color: #0f172a;
  background:
    radial-gradient(120% 90% at 0% 0%, rgba(147, 51, 234, 0.10), transparent 60%),
    radial-gradient(120% 100% at 100% 100%, rgba(59, 130, 246, 0.10), transparent 60%),
    linear-gradient(135deg, #ffffff 0%, #f8fafc 60%, #eef2ff 100%);
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow:
    0 24px 48px -28px rgba(79, 70, 229, 0.25),
    0 8px 22px -14px rgba(15, 23, 42, 0.12);
}

.agency-welcome::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background-image:
    radial-gradient(rgba(99, 102, 241, 0.18) 1px, transparent 1.4px),
    radial-gradient(rgba(59, 130, 246, 0.10) 1px, transparent 1.4px);
  background-size: 28px 28px, 56px 56px;
  background-position: 0 0, 14px 14px;
  opacity: 0.35;
  pointer-events: none;
}

.agency-welcome__decor {
  position: absolute;
  border-radius: 50%;
  filter: blur(56px);
  pointer-events: none;
  z-index: -1;
}

.agency-welcome__decor--1 {
  width: 320px;
  height: 320px;
  top: -140px;
  left: -100px;
  background: rgba(244, 114, 182, 0.22);
}

.agency-welcome__decor--2 {
  width: 360px;
  height: 360px;
  bottom: -180px;
  right: -140px;
  background: rgba(59, 130, 246, 0.22);
}

.agency-welcome__decor--3 {
  width: 220px;
  height: 220px;
  top: 30%;
  right: 18%;
  background: rgba(56, 189, 248, 0.18);
}

.agency-welcome__inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.agency-welcome__badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  align-self: flex-start;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(99, 102, 241, 0.10);
  border: 1px solid rgba(99, 102, 241, 0.25);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #4338ca;
}

.agency-welcome__badge .material-symbols-outlined {
  font-size: 18px;
  color: #4f46e5;
}

.agency-welcome__title {
  margin: 0;
  font-size: 32px;
  line-height: 1.1;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.agency-welcome__title-accent {
  background: linear-gradient(90deg, #9333ea, #4f46e5, #2563eb);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.agency-welcome__subtitle {
  margin: 0;
  max-width: 640px;
  font-size: 15px;
  line-height: 1.55;
  color: rgba(15, 23, 42, 0.7);
}

.agency-welcome__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 4px;
}

.agency-welcome__btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  border: 1px solid transparent;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}

.agency-welcome__btn .material-symbols-outlined {
  font-size: 18px;
}

.agency-welcome__btn--primary {
  color: #ffffff;
  background: linear-gradient(135deg, #6d28d9 0%, #4f46e5 55%, #2563eb 100%);
  box-shadow: 0 14px 26px -12px rgba(79, 70, 229, 0.55);
}

.agency-welcome__btn--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 18px 30px -12px rgba(79, 70, 229, 0.65);
  filter: brightness(1.04);
}

.agency-welcome__btn--ghost {
  background: rgba(255, 255, 255, 0.7);
  border-color: rgba(15, 23, 42, 0.14);
  color: #4338ca;
}

.agency-welcome__btn--ghost:hover {
  background: #ffffff;
  border-color: rgba(79, 70, 229, 0.45);
  transform: translateY(-1px);
}

.agency-welcome__highlights {
  list-style: none;
  margin: 18px 0 0;
  padding: 0;
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.agency-welcome__highlights li {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 14px;
  box-shadow: 0 6px 14px -10px rgba(15, 23, 42, 0.18);
}

.agency-welcome__highlights .material-symbols-outlined {
  font-size: 24px;
  color: #6366f1;
  flex-shrink: 0;
}

.agency-welcome__highlights strong {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 2px;
}

.agency-welcome__highlights p {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: rgba(15, 23, 42, 0.65);
}

@media (max-width: 640px) {
  .agency-welcome {
    padding: 28px 22px;
  }

  .agency-welcome__title {
    font-size: 26px;
  }
}
</style>
